<template>
  <section v-if="coupons.length" class="promos-carousel">
    <div
      v-for="coupon in coupons"
      v-if="coupon.active"
      @key="coupon.couponCode"
    >
      {{ coupon.message }}
    </div>
  </section>
</template>

<script>
import {marketplaceApi} from '../../js/marketplace/apis/marketplace';

export default {
  name: 'SloPromosCarousel',
  data() {
    return {
      coupons: []
    };
  },
  async created() {
    await marketplaceApi.getCurrentCoupons()
      .then(res => this.coupons = [res.data])
      .catch(() => false);
  }
};
</script>

<style lang="scss">
.promos-carousel {
  color: #fff;
}
</style>
